const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  roles: state => state.user.roles,
  permissions: state => state.user.permissions,
  addRouters: state => state.permission.addRouters,
  permission_routers: state => state.permission.routers,
  userInfo: state => state.user.userInfo,
}
export default getters
